module.exports = __webpack_public_path__ + "img/cash_register.b72c2b21.png";